import * as React from "react"
import { useIntl } from "react-intl"

import "./ErrorAlert.scss"

interface ErrorAlertProps {
	onClick: () => void
	hide: boolean

	message?: string
}
const ErrorAlert: React.FC<ErrorAlertProps> = (
	props: ErrorAlertProps
): React.ReactElement => {
	const intl = useIntl()

	const { onClick, hide, message } = props
	const handleCloseOnClick = (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		event.preventDefault()
		onClick()
	}

	const getCustomMessageOrDefaultError = (): string => {
		if (message?.startsWith("phronesis.")) {
			return message
		}

		return "phronesis.error.title"
	}

	if (hide) {
		return <React.Fragment />
	}

	return (
		<div className="alert">
			<span className={"message"}>
				{intl.formatMessage({
					id: getCustomMessageOrDefaultError(),
					defaultMessage: "Oh! an unexpected error occurred",
				})}
			</span>
			<button
				className={"close-button"}
				aria-label={"close alert message"}
				onClick={handleCloseOnClick}
			>
				<span aria-hidden="true">×</span>
			</button>
		</div>
	)
}

export default ErrorAlert
